export default {"src":"/_next/static/media/pin.bd29a3c2.svg","height":17,"width":12,"blurWidth":0,"blurHeight":0};